module.exports = __webpack_public_path__ + "static/media/background.32bc4b0e.jpg";